// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sidebar-toggle[data-v-e540a27e] {
    display: flex;
}
.sidebar-toggle-left[data-v-e540a27e] {
    display: flex;
    flex: 0 1px;
    transition: all 300ms;
    overflow-y: scroll;
}
.sidebar-toggle-left[data-v-e540a27e] > :first-child {
    flex: 1;
}
.sidebar-toggle-section[data-v-e540a27e] {
    flex: 1;
    overflow-y: auto;
}
.sidebar-toggle-right[data-v-e540a27e] {
    position: relative;
    display: flex;
    flex: 0 1;
    transition: all 300ms;
    overflow-y: scroll;
}
.sidebar-toggle-right[data-v-e540a27e] > :last-child {
    flex: 1;
}

/* SIZES */

/* Left sidebar */
.sidebar-toggle-left[data-v-e540a27e] {
    flex-basis: 160px;
    font-size: .9rem;
}
.sidebar-toggle-hidden.sidebar-toggle-left[data-v-e540a27e] {
    margin-left: -150px; /* The aside flex width minus the toggle bar's width */
}
@media (min-width: 992px) {
.sidebar-toggle-left[data-v-e540a27e] {
        flex-basis: 220px;
        font-size: 1rem;
}
.sidebar-toggle-hidden.sidebar-toggle-left[data-v-e540a27e] {
        margin-left: -212px; /* The aside flex width minus the toggle bar's width */
}
}

/* Right sidebar */
.sidebar-toggle-right[data-v-e540a27e] {
    flex-basis: 220px;
}
.sidebar-toggle-hidden.sidebar-toggle-right[data-v-e540a27e] {
    margin-right: -210px; /* The aside flex width minus the toggle bar's width */
}
@media (min-width: 1200px) {
.sidebar-toggle-right[data-v-e540a27e] {
        flex-basis: 280px;
}
.sidebar-toggle-hidden.sidebar-toggle-right[data-v-e540a27e] {
        margin-right: -270px; /* The aside flex width minus the toggle bar's width */
}
}

`, "",{"version":3,"sources":["webpack://./src/common/sidebar-toggle/SidebarToggle.vue"],"names":[],"mappings":";AAkDA;IACA,aAAA;AACA;AAEA;IACA,aAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;AACA;AAEA;IACA,OAAA;AACA;AAEA;IACA,OAAA;IACA,gBAAA;AACA;AAEA;IACA,kBAAA;IACA,aAAA;IACA,SAAA;IACA,qBAAA;IACA,kBAAA;AACA;AAEA;IACA,OAAA;AACA;;AAEA,UAAA;;AAEA,iBAAA;AAEA;IACA,iBAAA;IACA,gBAAA;AACA;AAEA;IACA,mBAAA,EAAA,sDAAA;AACA;AAEA;AACA;QACA,iBAAA;QACA,eAAA;AACA;AAEA;QACA,mBAAA,EAAA,sDAAA;AACA;AACA;;AAEA,kBAAA;AAEA;IACA,iBAAA;AACA;AAEA;IACA,oBAAA,EAAA,sDAAA;AACA;AAEA;AACA;QACA,iBAAA;AACA;AAEA;QACA,oBAAA,EAAA,sDAAA;AACA;AACA","sourcesContent":["<template>\n    <div class=\"sidebar-toggle\">\n        <aside v-if=\"$slots.leftSidebar\" :class=\"{ 'sidebar-toggle-hidden': !isOpen(leftName) }\"\n               class=\"sidebar-toggle-left position-relative d-none d-md-flex\">\n            <slot name=\"leftSidebar\"></slot>\n\n            <SidebarToggleBar :name=\"leftName\"/>\n        </aside>\n\n        <section class=\"sidebar-toggle-section\">\n            <slot></slot>\n        </section>\n\n        <aside v-if=\"$slots.rightSidebar\" :class=\"{ 'sidebar-toggle-hidden': !isOpen(rightName) }\"\n               class=\"sidebar-toggle-right d-none d-md-flex\">\n            <SidebarToggleBar :name=\"rightName\" :placement-right=\"true\"/>\n\n            <slot name=\"rightSidebar\"></slot>\n        </aside>\n    </div>\n</template>\n\n<script>\nimport SidebarToggleBar from './SidebarToggleBar'\n\nexport default {\n    name: \"SidebarToggle\",\n    components: {\n        SidebarToggleBar\n    },\n    props: {\n        name: String\n    },\n    computed: {\n        leftName() {\n            return this.name + 'Left'\n        },\n        rightName() {\n            return this.name + 'Right'\n        },\n    },\n    methods: {\n        isOpen(name) {\n            return this.$store.state.sidebarToggle[name]\n        }\n    },\n}\n</script>\n\n<style scoped>\n.sidebar-toggle {\n    display: flex;\n}\n\n.sidebar-toggle-left {\n    display: flex;\n    flex: 0 1px;\n    transition: all 300ms;\n    overflow-y: scroll;\n}\n\n.sidebar-toggle-left > :first-child {\n    flex: 1;\n}\n\n.sidebar-toggle-section {\n    flex: 1;\n    overflow-y: auto;\n}\n\n.sidebar-toggle-right {\n    position: relative;\n    display: flex;\n    flex: 0 1;\n    transition: all 300ms;\n    overflow-y: scroll;\n}\n\n.sidebar-toggle-right > :last-child {\n    flex: 1;\n}\n\n/* SIZES */\n\n/* Left sidebar */\n\n.sidebar-toggle-left {\n    flex-basis: 160px;\n    font-size: .9rem;\n}\n\n.sidebar-toggle-hidden.sidebar-toggle-left {\n    margin-left: -150px; /* The aside flex width minus the toggle bar's width */\n}\n\n@media (min-width: 992px) {\n    .sidebar-toggle-left {\n        flex-basis: 220px;\n        font-size: 1rem;\n    }\n\n    .sidebar-toggle-hidden.sidebar-toggle-left {\n        margin-left: -212px; /* The aside flex width minus the toggle bar's width */\n    }\n}\n\n/* Right sidebar */\n\n.sidebar-toggle-right {\n    flex-basis: 220px;\n}\n\n.sidebar-toggle-hidden.sidebar-toggle-right {\n    margin-right: -210px; /* The aside flex width minus the toggle bar's width */\n}\n\n@media (min-width: 1200px) {\n    .sidebar-toggle-right {\n        flex-basis: 280px;\n    }\n\n    .sidebar-toggle-hidden.sidebar-toggle-right {\n        margin-right: -270px; /* The aside flex width minus the toggle bar's width */\n    }\n}\n\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
